<template>
    <div style="margin:0 -12px;">
        <div class="container-fluid" style="position:absolute; background:#FF2AA3;color:#fff;z-index:999999999999"
            id="send_alert" v-if="is_send">
            <div class="row">
                <div class="col text-center" style="padding:15px 0;">
                    <small>
                        パスワードの変更が完了しました。
                    </small>
                </div>
            </div>
        </div>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center">
                        <h5>パスワード設定</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br>
            <div class="container-fluid" style="padding-top:56px;">
                <div class="row justify-content-center">
                    <div class="col-11" style="padding-top:5px;">
                        <input type="password" class="luna-form-control" id="luna_password" name="luna_password"
                            placeholder="登録するパスワードを入力" v-model="luna_password" />
                        <p class="error-text" v-if="isPasswordTooShort">
                            <i class="bi bi-x-circle-fill"></i>パスワードは{{ minPasswordLength }}文字以上で入力してください
                        </p>
                        <p class="error-text" v-if="isPasswordMissingCharTypes">
                            <i class="bi bi-x-circle-fill"></i>パスワードは英字と数字をそれぞれ含めてください
                        </p>
                        <div class="text-end" style="padding:10px 0;font-size:12px;">
                            <a href="/auth/password/reset">パスワードを忘れた方はこちら</a>
                        </div>
                        <input type="password" class="luna-form-control" id="luna_password_conf" name="luna_password_conf"
                            placeholder="確認用" v-model="luna_password_conf" />
                        <p class="error-text" v-if="isPasswordMismatch">
                            <i class="bi bi-x-circle-fill"></i>確認用パスワードが一致しません
                        </p>
                        <br />
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-8">
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna-d disabled" style="font-size:18px; padding:12px 0;"
                                v-if="isInValidPass">設定する</button>
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setAuthPass()" v-else>設定する</button>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: [],
            luna_password: "",
            luna_password_conf: "",
            minPasswordLength: 8,
            is_error: false,
            is_error_none: false,
            is_chenge: false,
            is_load: false,
            is_send: false,
            alertTimeoutId: null,
        };
    },
    methods: {
        async fetchUsers() {
            let response = await axios.get("/api/user/status")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    }
                })
        },
        async setAuthPass() {
            if (this.luna_password.length < this.minPasswordLength) {
                this.$showErrorToast(`パスワードは${this.minPasswordLength}文字以上で入力してください`);
                return
            }
            if (this.isPasswordMissingCharTypes) {
                this.$showErrorToast('パスワードは英字と数字をそれぞれ含めてください');
                return
            }
            if (this.luna_password !== this.luna_password_conf) {
                this.$showErrorToast('パスワードが一致しません');
                return
            }
            await axios.post("/api/auth/pass/mod", {
                password: this.luna_password,
            })
                .then((response) => {
                    this.luna_password = ''
                    this.luna_password_conf = ''
                    this.showAlertTemporarily()
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('パスワードの変更に失敗しました。');
                    }
                })
        },
        showAlertTemporarily() {
            if (this.alertTimeoutId) {
                clearTimeout(this.alertTimeoutId)
            }
            this.is_send = true
            this.alertTimeoutId = setTimeout(() => {
                this.is_send = false
                this.alertTimeoutId = null
            }, 3000)
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    })
            }
            else {
                this.fetchUsers()
            }
        }
        else {
            this.fetchUsers()
        }
    },
    computed: {
        isPasswordTooShort() {
            return this.luna_password !== "" && this.luna_password.length < this.minPasswordLength
        },
        isPasswordMissingCharTypes() {
            if (this.luna_password === "") {
                return false
            }
            const hasLetter = /[A-Za-z]/.test(this.luna_password)
            const hasNumber = /[0-9]/.test(this.luna_password)
            return !(hasLetter && hasNumber)
        },
        isPasswordMismatch() {
            if (this.luna_password === "" || this.luna_password_conf === "") {
                return false
            }
            return this.luna_password !== this.luna_password_conf
        },
        isInValidPass() {
            if (this.luna_password === "") {
                return true
            }
            if (this.isPasswordTooShort) {
                return true
            }
            if (this.isPasswordMissingCharTypes) {
                return true
            }
            if (this.luna_password_conf === "") {
                return true
            }
            if (this.isPasswordMismatch) {
                return true
            }

            return false
        }
    },
    beforeDestroy() {
        if (this.alertTimeoutId) {
            clearTimeout(this.alertTimeoutId)
        }
    }
};
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 20px;
    height: 60px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.error-text {
    margin: 4px 8px;
}
</style>
